import { useEffect, useState } from '@wordpress/element';
import { POST_ID } from '../../routes/Variables';
import { useAnalisesPostObter } from './useAnalisesPostObter';
import { useAnalisesPostGerar } from './useAnalisesPostGerar';
import { useContext } from '@wordpress/element';
import ContextTela from '@pages/DicasOtimizacao/telaContext';

export const useAnalisesPost = ({
  tipo = '',
  executarAutomaticamente = true,
  idPost = POST_ID,
}) => {
  const [resultado, setResultado] = useState({
    analise: null,
    carregando: executarAutomaticamente,
    erro: null,
  });

  const { tela } = useContext(ContextTela);

  const { gerarAnalise, resultado: novosResultados } = useAnalisesPostGerar({ idPost, tipo });
  const { obterAnalises, resultado: resultadosWp } = useAnalisesPostObter({
    idPost,
    acaoWp: 'obter_analises',
    tipo,
  });

  useEffect(() => {
    if (tela != null && tela != undefined) {
      document.addEventListener(`analise-${tela}-${tipo}`, handleEventoTelaOposta);
    }
  }, [tela]);

  // Handler para receber eventos da tela oposta
  const handleEventoTelaOposta = (event) => {
    if (event.detail.status === 'CARREGANDO')
      setResultado({ analise: null, erro: null, carregando: true });
    else if (event.detail.status === 'FINALIZADO')
      obterAnalises();
    else
      console.warn("Status desconhecido: ", event.detail.status)
  };

  useEffect(() => {
    if (!executarAutomaticamente) {
      setResultado(prev => ({ ...prev, carregando: false }));
      return;
    }

    setResultado(resultadosWp);

    if (resultadosWp.analise && resultadosWp.analise.length === 0) {
      gerarAnalise();
    }
  }, [resultadosWp]);

  useEffect(() => {
    if (novosResultados.carregando) {
      setResultado({ analise: null, erro: null, carregando: true });
    }

    if (!novosResultados.carregando) {
      setResultado(novosResultados);
    }
  }, [novosResultados]);

  return {
    ...resultado,
    obterAnalises,
    gerarNovaAnalise: gerarAnalise,
  };
};
